import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useMarketMapStore = defineStore('marketMap', {
  state: () => ({
    filter: {
      games: [],
      stores: [],
      allOffers: false
    }
  }),
  getters: {
    isFilterActive(state) {
      return state.filter.games.length > 0 || state.filter.stores.length > 0 || state.filter.allOffers
    },
    activeFilterCount(state) {
      let count = 0
      if (state.filter.games.length > 0) count++
      if (state.filter.stores.length > 0) count++
      if (state.filter.allOffers) count++
      return count
    },
  },
  actions: {
    async action_getAllMarketMaps() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2075,
      };
      //console.log('action_getAllMarketMaps Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getAllMarketMaps Success: ', response);
          return {
            result: true,
            data: response.data.watchdogs3
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_changeOfferPrice(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2080,
        "g2g": {
          "offer":
            {
              "id": payload.id,
              "price": payload.price,
              "store": payload.store,
              ...(payload.game === "WoW Classic Era" && {
                "wholesalePrice": payload.wholesalePrice,
                "wholesaleQuantity": payload.wholesaleQuantity
              })
            }
        }
      };
      //console.log('action_changeOfferPrice Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_changeOfferPrice Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_updateMarket(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2079,
        "watchdog3": {
          "game": payload.game,
          "server": payload.server,
          "store": payload.store,
          "notifyChanges": payload.notifyChanges,
          "isActive": payload.isActive
        }
      };
      //console.log('action_updateMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_updateMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_removeMarket(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2077,
        "watchdog3": {
          "game": payload.game,
          "server": payload.server,
          "store": payload.store,
        }
      };
      //console.log('action_removeMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_removeMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_addMarket(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2076,
        "watchdog3": {
          "game": payload.game,
          "server": payload.server,
          "store": payload.store,
          "priceLink": payload.priceLink,
          "lowestPricesLink": payload.lowestPricesLink,
          "notifyChanges": payload.notifyChanges,
          "isActive": payload.isActive
        }
      };
      console.log('action_addMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_removeMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_getAllMarketMaps4() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2100,
      };
      //console.log('action_getAllMarketMaps Request: ', request);
      return await useApi(
        request,
        (response) => {
          const data = response.data.watchdogs4.map(market => ({
            ...market,
            competitors: Object.fromEntries(
              Object.entries(market.competitors || {})
                .sort(([, a], [, b]) => Number(a.price) - Number(b.price))
            )
          }))

          return {
            result: true,
            data
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_addWatchdog4(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2101,
        "watchdog4": {
          "game": payload.game,
          "server": payload.server,
          "link": payload.link,
          "notifyChanges": payload.notifyChanges,
          "isActive": payload.isActive
        }
      };
      console.log('action_addMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_removeMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_removeMarket4(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2102,
        "watchdog4": {
          "game": payload.game,
          "server": payload.server,
        }
      };
      console.log('action_removeMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_removeMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_setStore4(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2105,
        "watchdog4": {
          "game": payload.game,
          "server": payload.server,
          "stores": payload.stores,
        }
      };
      console.log('action_addStore4 Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_addStore4 Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_updateMarket4(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2103,
        "watchdog4": {
          "game": payload.game,
          "server": payload.server,
          "link": payload.store,
          "notifyChanges": payload.notifyChanges,
          "isActive": payload.isActive
        }
      };
      //console.log('action_updateMarket Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_updateMarket Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    getFilteredOffers(markets, searchTerm = '') {
      if (!markets?.length) return []

      const term = searchTerm.toLowerCase().trim()
      const {games, stores, allOffers} = this.filter

      return markets.filter(market => {
        if (games.length && !games.includes(market.game)) {
          return false
        }

        if (stores.length) {
          const marketStoreMatch = (market.stores || []).some(store =>
            stores.includes(store.store)
          )

          const competitorMatch = Object.keys(market.competitors || {}).some(
            competitor => stores.includes(competitor)
          )

          if (!marketStoreMatch && !competitorMatch) {
            return false
          }
        }

        if (!allOffers && !market.isActive) {
          return false
        }

        if (!term) return true

        const marketMatch =
          (market.game || '').toLowerCase().includes(term) ||
          (market.server || '').toLowerCase().includes(term)

        if (marketMatch) return true

        const storeMatch = (market.stores || []).some(store =>
          (store.store || '').toLowerCase().includes(term) ||
          (store.offerID || '').toLowerCase().includes(term)
        )

        if (storeMatch) return true

        return Object.keys(market.competitors || {}).some(competitor =>
          competitor.toLowerCase().includes(term)
        )
      })
    }
  }
});
